import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetService, useUpdateService } from "@/hooks/services";
import { CreateService, Service } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(services)/services/_sheet/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { isLoading, data: model } = useGetService(id);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} />;
}

function Edit({ model }: { model: Service }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateService({
    onSuccess: (service) => {
      navigate({
        to: "/services",
        params: { id: service.id.toString() },
      });
    },
  });

  const update = async (service: CreateService) => {
    await mutateAsync({ id: model.id, ...service });
  };
  return <Form model={model} onUpsert={update} />;
}
